import { Separator } from "@/components/ui/separator";
import { Skeleton } from "@/components/ui/skeleton";

interface ContractDetailsSkeletonProps {
  showSidebars?: boolean; // default true
}

export default function ContractDetailsSkeleton({
  showSidebars = true,
}: ContractDetailsSkeletonProps) {
  return (
    <div className="flex flex-col lg:flex-row lg:gap-8 w-full">
      {/* MAIN CARD */}
      <div className="w-full ">
        <div className="flex flex-col gap-4 rounded-2xl bg-white md:py-5 md:px-8 py-4 px-5 shadow-sm">
          {/* Header */}
          <header className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <Skeleton className="h-6 w-48" /> {/* "Contrato nº 0000" */}
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-10" /> {/* "Status:" */}
              <Skeleton className="h-6 w-32 rounded-full" /> {/* Badge */}
            </div>
          </header>

          <Separator />

          <section className="flex flex-col gap-4">
            <Skeleton className="h-5 w-48" />{" "}
            {/* título "Informações gerais" */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-4">
              {Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="space-y-2">
                  <Skeleton className="h-3 w-24" />
                  <Skeleton className="h-4 w-32" />
                </div>
              ))}
            </div>
          </section>

          <Separator />

          {/* TransportTimelineV2 mimic */}
          <section className="overflow-x-auto md:overflow-visible">
            <div className="flex">
              <ul className="flex flex-col items-start pr-10 space-y-8">
                {Array.from({ length: 4 }).map((_, idx) => (
                  <li key={idx} className="relative flex gap-4">
                    {/* Linha vertical */}
                    {idx !== 3 && (
                      <span
                        aria-hidden
                        className="absolute left-5 top-10 -bottom-8 border-l-2 border-dashed border-gray-200"
                      />
                    )}

                    {/* "círculo" */}
                    <Skeleton className="w-10 h-10 rounded-full" />

                    {/* bloco texto */}
                    <div className="flex-1 pt-2 space-y-2">
                      <Skeleton className="h-4 w-56" />
                      <Skeleton className="h-3 w-[90%]" />
                      <Skeleton className="h-3 w-2/3" />
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </section>

          <Separator />

          {/* DriverInfo mimic */}
          <section className="space-y-4">
            <Skeleton className="h-5 w-44" /> {/* titulo */}
            <div className="flex items-center gap-6 border border-gray-200 rounded-2xl bg-white p-6 shadow-sm">
              <Skeleton className="w-16 h-16 rounded-full" />
              <div className="grid grid-cols-3 gap-8 flex-1">
                {Array.from({ length: 3 }).map((_, i) => (
                  <div key={i} className="space-y-2">
                    <Skeleton className="h-3 w-24" />
                    <Skeleton className="h-4 w-32" />
                    {i === 0 && <Skeleton className="h-2 w-20" />}{" "}
                    {/* subtítulo */}
                  </div>
                ))}
              </div>
            </div>
          </section>

          <Separator />

          {/* Map mimic */}
          <section className="space-y-4">
            <Skeleton className="h-64 w-full rounded-2xl" />
          </section>

          <Separator />

          {/* FreightDetailsCard mimic */}
          <section className="flex flex-col gap-4">
            <Skeleton className="h-5 w-40" /> {/* título "Detalhes do frete" */}
            {/* 4 campos superiores */}
            <div className="grid grid-cols-2 gap-x-6 gap-y-4">
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="space-y-2">
                  <Skeleton className="h-3 w-28" />
                  <Skeleton className="h-4 w-40" />
                </div>
              ))}
            </div>
            {/* 4 campos do meio */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-4">
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="space-y-2">
                  <Skeleton className="h-3 w-24" />
                  <Skeleton className="h-4 w-28" />
                </div>
              ))}
            </div>
            <Separator />
            {/* 5 campos finais */}
            <div className="grid grid-cols-2 md:grid-cols-5 gap-x-6 gap-y-4">
              {Array.from({ length: 5 }).map((_, i) => (
                <div key={i} className="space-y-2">
                  <Skeleton className="h-3 w-24" />
                  <Skeleton className="h-4 w-28" />
                </div>
              ))}
            </div>
          </section>

          <Separator />

          {/* FAQ Card mimic */}
          <section className="space-y-3">
            <Skeleton className="h-5 w-64" />
            <Skeleton className="h-4 w-72" />
            <Skeleton className="h-9 w-32 rounded-md" />
          </section>
        </div>
      </div>

      {/* SIDEBARS */}
      {showSidebars && (
        <></>
        // <div className="w-full lg:basis-[30%] flex flex-col gap-6 mt-10 lg:mt-0">
        //   {/* Sidebar 1 - FAQ small card */}
        //   <aside className="hidden lg:flex w-full flex-col">
        //     <div className="flex flex-col gap-5 rounded-2xl bg-white py-4 px-8 shadow-sm">
        //       <Skeleton className="h-5 w-56" />
        //       <Skeleton className="h-4 w-60" />
        //       <Skeleton className="h-9 w-40 rounded-md" />
        //     </div>
        //   </aside>

        //   {/* Sidebar 2 - CepOptionCard coleta */}
        //   <aside className="hidden lg:flex w-full flex-col">
        //     <div className="flex flex-col gap-5 rounded-2xl bg-white py-4 px-8 shadow-sm">
        //       <Skeleton className="h-5 w-80" />
        //       <CepOptionSkeleton />
        //     </div>
        //   </aside>

        //   {/* Sidebar 3 - CepOptionCard entrega */}
        //   <aside className="hidden lg:flex w-full flex-col">
        //     <div className="flex flex-col gap-5 rounded-2xl bg-white py-4 px-8 shadow-sm">
        //       <Skeleton className="h-5 w-80" />
        //       <CepOptionSkeleton />
        //     </div>
        //   </aside>
        // </div>
      )}
    </div>
  );
}
